<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Complete the following table, by converting the given temperatures between Celsius and
        Kelvin units, as required:
      </p>

      <v-simple-table style="max-width: 350px">
        <thead>
          <tr>
            <td style="font-size: 14px">Part</td>
            <td style="text-align: center; font-size: 14px">Temp (<sup>o</sup>C)</td>
            <td style="text-align: center; font-size: 14px">Temp (K)</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>a)</td>
            <td style="text-align: center"><number-value :value="tempC1" /></td>
            <td>
              <calculation-input
                v-model="inputs.tempK1"
                class="centered-input pa-2"
                dense
                :disabled="!allowEditing"
              />
            </td>
          </tr>
          <tr>
            <td>b)</td>
            <td style="text-align: center"><number-value :value="tempC2" /></td>
            <td>
              <calculation-input
                v-model="inputs.tempK2"
                class="centered-input pa-2"
                dense
                :disabled="!allowEditing"
              />
            </td>
          </tr>
          <tr>
            <td>c)</td>
            <td style="text-align: center"><number-value :value="tempC3" /></td>
            <td>
              <calculation-input
                v-model="inputs.tempK3"
                class="centered-input pa-2"
                dense
                :disabled="!allowEditing"
              />
            </td>
          </tr>
          <tr>
            <td>d)</td>
            <td>
              <calculation-input
                v-model="inputs.tempC4"
                class="centered-input pa-2"
                dense
                :disabled="!allowEditing"
              />
            </td>
            <td style="text-align: center"><number-value :value="tempK4" /></td>
          </tr>
          <tr>
            <td>e)</td>
            <td>
              <calculation-input
                v-model="inputs.tempC5"
                class="centered-input pa-2"
                dense
                :disabled="!allowEditing"
              />
            </td>
            <td style="text-align: center"><number-value :value="tempK5" /></td>
          </tr>
          <tr>
            <td>f)</td>
            <td>
              <calculation-input
                v-model="inputs.tempC6"
                class="centered-input pa-2"
                dense
                :disabled="!allowEditing"
              />
            </td>
            <td style="text-align: center"><number-value :value="tempK6" /></td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';
import NumberValue from '../NumberValue';

export default {
  name: 'Question375',
  components: {
    StembleLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        tempK1: null,
        tempK2: null,
        tempK3: null,
        tempC4: null,
        tempC5: null,
        tempC6: null,
      },
    };
  },
  computed: {
    tempC1() {
      return this.taskState.getValueBySymbol('tempC1').content;
    },
    tempC2() {
      return this.taskState.getValueBySymbol('tempC2').content;
    },
    tempC3() {
      return this.taskState.getValueBySymbol('tempC3').content;
    },
    tempK4() {
      return this.taskState.getValueBySymbol('tempK4').content;
    },
    tempK5() {
      return this.taskState.getValueBySymbol('tempK5').content;
    },
    tempK6() {
      return this.taskState.getValueBySymbol('tempK6').content;
    },
  },
};
</script>
